import React from 'react';

const CALCULATORS = [
  {
    href: '/professionals/resources/lifetime-mortgage-calculators/ism-calculator',
    icon: '/img/icons/percent-02.svg',
    alt: 'percent',
    title: 'Interest Servicing Calculator',
    description: 'Illustrate how clients can reduce the cost of borrowing with interest serviced lifetime mortgages.',
  },
  {
    href: '/professionals/resources/lifetime-mortgage-calculators/optional-partial-repayments-calculator',
    icon: '/img/icons/scales-01-alt.svg',
    alt: 'scales',
    title: 'Partial Repayments Calculator',
    description:
      'Illustrate the benefit of making optional partial repayments on our lifetime mortgages.',
  },
  {
    href: '/professionals/resources/lifetime-mortgage-calculators/annual-overpayments-and-erc-calculator',
    icon: '/img/icons/clock-rewind.svg',
    alt: 'clock',
    title: 'Annual Overpayments and ERC Calculator',
    description: 'Illustrate the benefit of making ad hoc lump sum payments and if ERCs are applicable.',
  },
  {
    href: '/professionals/resources/lifetime-mortgage-calculators/max-loan-to-value-calculator',
    icon: '/img/icons/coins-stacked-01.svg',
    alt: 'coins',
    title: 'Maximum Loan-to-Value Calculator',
    description: 'Complete a quick loan-to-value sense-check with our indicative maximum loan value calculator.',
  },
];

export const Calculators = () => (
  <>
    <div className="grid md:grid-cols-2 gap-10">
      {CALCULATORS.map((item, index) => (
        <a
          key={index}
          href={item.href}
          aria-label={item.title}
          className="card-focus rounded-xl"
        >
          <div className="h-full cursor-pointer rounded-xl border border-[#F3F4F8] bg-[#FFF] shadow-sm duration-500 hover:scale-105 hover:bg-[#F3F4F8] hover:bg-opacity-100">
            <div className="px-6 py-6">
              <img
                src={item.icon}
                alt={item.alt}
                className="mx-auto mb-4 h-8 w-8"
              />

              <div className="flex items-center justify-center">
                <div className="text-center">
                  <p className="text-[1.125rem] font-semibold text-[#373945] xl:w-[32rem]">
                    {item.title}
                  </p>

                  <p className="mb-8 text-base font-medium text-[#373945] xl:w-[32rem]">
                    {item.description}
                  </p>
                </div>
              </div>

              <p className="plain-text-link mb-6 flex items-center justify-center gap-[1.625rem] text-base font-semibold text-[#006EB7]">
                Calculate now
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M3 9H15M15 9L10.5 4.5M15 9L10.5 13.5"
                    stroke="#006EB7"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </p>
            </div>
          </div>
        </a>
      ))}
    </div>

    <p className="text-base text-[#373945] font-625 lg:text-center">
      Note: <span className="font-medium">Minimum and maximum payment rules apply please refer to your KFI/Offer for full details.</span>
    </p>
  </>
);
